<template>
  <v-card
    class="mb-5"
    outlined
    @click="e => $emit('click', e)"
  >
    <div class="d-flex align-center pa-4">
      <!--<v-avatar :size="50">
        <v-img :src="tenant.urls.logo" />
      </v-avatar>-->
      <v-card-title class="py-0 pr-0">
        <div>{{ tenant.name }}</div>
      </v-card-title>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'ElacTenantsListItem',
  props: {
    tenant: {
      type: Object,
      default: () => ({
        name: '',
        urls: {
          logo: '',
        },
      }),
    },
  },
};
</script>
